import { CookieUtil, StoreUtil } from '@/utils'
import { UserInfo } from '@/interface'
/**
 * at埋点系统模块
 * click 事件 - 通过 doAtEvent 来绑定
 * */

//  initAtAction: function (off, target) {
//   if (this.checkAtSdk()) {
//       // action event
//       if (off) {
//           $(target).unbind("click");
//       }
//       $(target).on('click', function (event) {
//           var title = atModel.getTitle(event.currentTarget);
//           atModel.doAtEvent(title, 'action', event);
//       });
//   }
// }

export const loadSmartTag = () => {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = 'https://tag.aticdn.net/628978/smarttag.js'
  document.querySelector('body')?.append(script)
}

export const ACTION_TYPES = {
  action: 'action',
  download: 'download',
  navigation: 'navigation'
}

// 检查at模块是否已加载
function checkAtSdk () {
  return window?.ATInternet?.Tracker
}

// 做url跳转时，防止埋点失效的延迟
export const DELAY_FOR_BURY_INFO = 500

export const checkCookieDisabled = () => {
  const Store = StoreUtil.getCookieStore()
  const isOn = Store.configs.find(item => item.id === CookieUtil.COOKIE_MANAGE_CONFIGURATION.analytics.id)?.isOn
  if (isOn !== CookieUtil.COOKIE_STATUS.true) {
    CookieUtil.deleteCookieById(CookieUtil.COOKIE_MANAGE_CONFIGURATION.analytics.id)
  }
  return isOn !== CookieUtil.COOKIE_STATUS.true
}

export class AtModel {
  atTag: any = null
  clientId = null
  constructor () {
    this.init()
  }

  static doPageEvent (userInfo: UserInfo | null) {
    if (checkAtSdk()) {
      const disableCookie = checkCookieDisabled()
      // set page
      const atTag = new window.ATInternet.Tracker.Tag({ disableCookie })
      const HOST = location.origin
      const PREFIX = window.prefix
      const PAGE_INFO = {
        name: '',
        language: PREFIX
      }
      const CUSTOM_VAR_INFO = {
        site: {
          // referer
          2: `[${HOST}/${PREFIX}/]`,
          // url
          3: `[${window.location.href}]`
        }
      }
      const hikId = CookieUtil.getCookie('USERID') || CookieUtil.getCookie('HIKUSERID')
      const IDENTIFIED_VISITOR_INFO = {
        id: hikId || '',
        category: userInfo?.typeId
      }
      // atTag.page.set(PAGE_INFO)
      const message: Record<string, any> = {
        ...PAGE_INFO,
        customVars: CUSTOM_VAR_INFO
      }
      atTag.customVars.set(CUSTOM_VAR_INFO)
      if (userInfo) {
        atTag.identifiedVisitor.set(IDENTIFIED_VISITOR_INFO)
        message.identifiedVisitor = IDENTIFIED_VISITOR_INFO
      }
      // console.log('on send', atTag)
      // console.log('on send info', userInfo ? IDENTIFIED_VISITOR_INFO : null)
      try {
        atTag.page.send(message)
      } catch (err: unknown) {
        console.error('ON_AT_PAGE_SEND_ERROR:', err)
      }
    }
  }

  // 初始化
  init () {
    if (checkAtSdk() && !checkCookieDisabled()) {
      this.initAtPage()
    }
  }

  // 初始化page info
  initAtPage () {
    this.atTag = new window.ATInternet.Tracker.Tag()
    // initAtClientIdAndSave
    const currentId = this.atTag.clientSideUserId.get()
    if (this.clientId || this.clientId !== currentId) {
      this.clientId = currentId
    }

    // 先不发page info
    this.atTag.dispatch()
  }

  // 更新title
  getTitle (title: string) {
    const url = location.origin + location.pathname
    return title + `::${url}`
  }

  /**
   * @param {title} 埋点的文本信息
   * @param {actionType} 埋点的类型，从ACTION_TYPES里面获取
   * @param {event} 事件的event对象, 透传过来
  */
  doAtEvent (title: string, actionType: string, event?: Event) {
    if (checkCookieDisabled()) {
      // 当用户在gdpr关闭cookie后，在这里阻止埋点
      return
    }
    let finalTitle = this.getTitle(title)
    // console.log('final title on at', finalTitle)
    const e = event || {
      currentTarget: null,
      target: null
    }
    // 去掉非法字符
    finalTitle = finalTitle.replace(/\&/g, '')
    if (this.atTag) {
      this.atTag.click.send({
        elem: e.currentTarget ? e.currentTarget : e.target,
        name: finalTitle.toLowerCase().split(' ').join('_'),
        level2: 'clickLvl2',
        type: actionType,
        event: e
      })
    }
  }

  doActionEvent (title: string, event?: Event) {
    this.doAtEvent(title, ACTION_TYPES.action, event)
  }

  doNavigationEvent (title: string, event?: Event) {
    this.doAtEvent(title, ACTION_TYPES.navigation, event)
  }
}

/**
 * 获取链接最后一个节点
 * https://elearning-uat.hikvision.com/en/my-learning?csr=1
 * my-learning
 * */
export function getLastNodeInUrl (url: string) {
  if (typeof url !== 'string') return ''
  const lastNode = url.split('/').pop() || ''
  return lastNode.split('?')[0]
}

let atModel: null | AtModel = null

export function getAtModel (): AtModel {
  if (atModel) {
    return atModel
  }
  atModel = new AtModel()
  return atModel
}
